import React from "react"
import {
  withStyles,
  WithStyles,
  createStyles,
  Theme,
  Typography,
} from "@material-ui/core"

import { Section } from "../../../../../content/pages/global"
import Links from "./Links"
import { flexBreakpoint } from "../styles"

const getSectionWidth = (marginX: string): string => {
  const sections: number = 3
  return `calc(100% / ${sections} - ${marginX} / 2)`
}

const styles = ({
  palette: {
    text: { primary },
  },
  breakpoints: { up },
}: Theme) => {
  const width: string = getSectionWidth("3.9375rem")
  const widthXl: string = getSectionWidth("6.0625rem")

  const flexBreakpointUp = up(flexBreakpoint)

  return createStyles({
    root: {
      "& + &": {
        marginTop: "3.125rem",
        [flexBreakpointUp]: {
          marginTop: 0,
        },
      },
      [flexBreakpointUp]: {
        width,
        flexBasis: width,
      },
      [up("lg")]: {
        width: widthXl,
        flexBasis: widthXl,
      },
    },
    title: {
      fontSize: "1.125rem",
      fontWeight: 300,
      paddingBottom: "0.5rem",
      borderBottom: `1px solid ${primary}`,
      marginBottom: "2.3125rem",
    },
  })
}

interface Props extends WithStyles<typeof styles>, Section {}

const SectionItem = ({ classes, name, links }: Props) => {
  return (
    <section className={classes.root}>
      <Typography className={classes.title} variant="h2">
        {name}
      </Typography>
      <Links links={links} />
    </section>
  )
}

export default withStyles(styles)(SectionItem)
